import { SharedState } from '@trello/shared-state';

import type { FocusTimeDraft } from './Planner.types';

export interface FocusTimeDraftState {
  draft: FocusTimeDraft | null;
  isSaved: boolean;
}

export const focusTimeDraftState = new SharedState<FocusTimeDraftState>({
  draft: null,
  isSaved: false,
});
